import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks";

export default () => {
    const { response: { products } } = useAppState();
    const masterSet = new Set([])
    const [ swatchData, setSwatchData ] = useState([]);

    useEffect(() => {  
        if(!products?.hits || products.hits?.length < 1) return;

        var tagsToFetch;

        products?.hits?.map((product) =>{
            var masterTag = product?.tags1?.find(tag => tag.includes("YGroup_"))?.toString();
            masterSet.add(masterTag);
            let masterArray = Array.from(masterSet);
            tagsToFetch = masterArray;
        });

        

        const fetchRelatedProducts = async (master) => {
            let query = `
                query {
                    products(limit: 250, filter: {availability: "InStock", tags1: ${JSON.stringify(master)}}) {
                        products{
                            productId
                            name
                            tags1
                            availability
                            imageUrl
                            url
                            alternateImageUrls
                            price
                            listPrice
                            skus {
                                id
                                availability
                                attributes {
                                    key 
                                    value
                                }
                            }
                        }
                    }
                }`;
            const response = await fetch('https://api.nosto.com/v1/graphql', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/graphql',
                    'Authorization': 'Basic ' + btoa(":" + "gZiMXfdux0xMPYxM3gAcKUrw9ZOZUoWx8s7GVSUnSECofcymwlx9L0WZtpXarfV9")
                }),
                mode: 'cors',
                body: query
            })

            if (response?.status === 200){
                const data = await response.json()
                const fetchedResults = data?.data?.products?.products || []
                return fetchedResults;
            }
        }

        if(masterSet?.length < 1) return

        fetchRelatedProducts(tagsToFetch).then(data => {
            setSwatchData(data);
        })

    }, [ products ])

    return { swatchData }

}